import React, { useState } from "react";
import { _t } from "../app/i18n/i18n";

export const Truncate = ({ show, more, children, className = "", label = _t("more...") }) => {
  const [max, setMax] = useState(show);
  return [
    children.slice(0, max),
    max < children.length && (
      <MoreLabel key={2} label={label} max={max} setMax={setMax} more={more} className={className}></MoreLabel>
    ),
  ];
};

const MoreLabel = (props) => (
  <small className={props.className} onClick={() => props.setMax(props.max + props.more)}>
    <span className="text-nowrap cursor-pointer"> {props.label} </span>
  </small>
);
